import { useMemo } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { buildColumnsProveedores } from "../config/columns";
import { buildRowActions } from "./RowActionMenu";

const bgColorTableHeadCell = "rgba(212, 230, 241, 0.8)";

const ProveedoresTable = ({ data = [], loading, onAction, onNuevo }) => {
  const columns = useMemo(() => buildColumnsProveedores(), []);

  return (
    <Box boxShadow={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
      <MaterialReactTable
        columns={columns}
        data={data}
        localization={MRT_Localization_ES}
        enableRowActions
        positionActionsColumn="last"
        enableColumnActions={false}
        enableColumnFilters={false}
        enableColumnOrdering={false}
        enableGrouping={false}
        enableHiding={false}
        enableDensityToggle={false}
        enableSorting
        state={{ isLoading: loading, showSkeletons: loading }}
        initialState={{ density: "compact", pagination: { pageIndex: 0, pageSize: 25 } }}
        muiSearchTextFieldProps={{
          placeholder: "Buscar proveedor..",
          sx: { minWidth: "16rem", backgroundColor: "#ffffff" },
          variant: "outlined",
          size: "small",
        }}
        renderTopToolbarCustomActions={() => (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onNuevo}
            sx={{ borderRadius: 3, textTransform: "none", fontWeight: 600 }}
          >
            Nuevo proveedor
          </Button>
        )}
        muiTableHeadCellProps={{
          sx: {
            fontSize: 14,
            color: "black",
            fontWeight: "normal",
            backgroundColor: bgColorTableHeadCell,
            borderColor: "#FDFEFE",
          },
        }}
        muiTableBodyCellProps={{
          sx: { borderBottom: "1px solid rgba(224,224,224,1)" },
        }}
        renderRowActionMenuItems={({ closeMenu, row }) =>
          buildRowActions({ row: row.original, closeMenu, onAction })
        }
      />
    </Box>
  );
};

export default ProveedoresTable;
